import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
    // plugins: [createPersistedState({
    //     storage: window.localStorage
    // })],
    state: {
        isMenuCollapse: false,
        cancelTokenArr: [], // 取消token请求数组
        isLoading: false
    },
    getters: {
    },
    mutations: {
        changeMenuCollapse(state) {
            state.isMenuCollapse = !state.isMenuCollapse
        },
        pushCancelToken(state, cancel) {
            state.cancelTokenArr.push(cancel)
        },
        // 清空未完成请求
        clearCancelToken(state) {
            if (state.cancelTokenArr.length > 0) {
                state.cancelTokenArr.forEach((c, index) => {
                    if (c) {
                        c('路由跳转取消请求')
                    }
                })
                state.cancelTokenArr = []
            }
        },
        changeLoading(state, val) {
            state.isLoading = val
        }
    },
    actions: {
    },
    modules: {
    }
})
